export default "__VITE_ASSET__Bz5vyCB___"